import {Column} from 'react-table'
import {JudolCustomHeader} from './JudolCustomHeader'
import {JudolActionsCell} from './JudolActionsCell'
import {Judol} from '../../core/_models'
import {formatDate} from '../../../../../utils/date'
import {TipidkorCustomHeader} from '../../../../tipidkor/tipidkor-list/table/columns/TipidkorCustomHeader'
import {formatAttentionLevel} from '../../../../../utils/string'

const judolColumns: ReadonlyArray<Column<Judol>> = [
  {
    Header: (props) => (
      <JudolCustomHeader
        tableProps={props}
        title='No'
        className='min-w-75px'
        enableSort={false}
      />
    ),
    accessor: 'id',
    id: 'id',
    Cell: ({...props}) => (
      <>{props.row.index + 1}</>
    )
  },
  {
    Header: (props) => (
      <JudolCustomHeader
        tableProps={props}
        title='Wilayah'
        className='min-w-125px'
        enableSort={true}
      />
    ),
    accessor: 'satwilName',
    id: 'satwilName',
  },
  {
    Header: (props) => (
      <JudolCustomHeader tableProps={props} title='No LP' className='min-w-125px' enableSort={false} />
    ),
    accessor: 'policeReportNo',
    id: 'policeReportNo',
  },
  {
    Header: (props) => (
      <JudolCustomHeader
        tableProps={props}
        title='Level Atensi'
        className='min-w-125px'
        enableSort={true}
      />
    ),
    accessor: 'attentionLevel',
    id: 'attentionLevel',
    Cell: ({...props}) => (
      <>{formatAttentionLevel(props.data[props.row.index].attentionLevel)}</>
    )
  },
  {
    Header: (props) => (
      <JudolCustomHeader
        tableProps={props}
        title='Tahap'
        className='min-w-125px'
        enableSort={false}
      />
    ),
    accessor: 'caseStatusName',
    id: 'caseStatusName',
  },
  {
    Header: (props) => (
      <JudolCustomHeader
        tableProps={props}
        title='Tanggal LP'
        className='min-w-125px'
        enableSort={false}
      />
    ),
    accessor: 'policeReportDate',
    id: 'policeReportDate',
    Cell: ({...props}) => (
      <>{formatDate(props.data[props.row.index].policeReportDate ?? new Date())}</>
    ),
  },
  {
    Header: (props) => (
      <JudolCustomHeader
        tableProps={props}
        title='Tanggal Input'
        className='min-w-150px'
        enableSort={true}
      />
    ),
    accessor: 'createdAt',
    id: 'createdAt',
    Cell: ({...props}) => (
      <>{formatDate(props.data[props.row.index].createdAt || '')}</>
    ),
  },
  {
    Header: (props) => (
      <JudolCustomHeader
        tableProps={props}
        title='Status'
        className='min-w-125px'
        enableSort={false}
        stickyEnd={100}
        stickyBorder={true}
      />
    ),
    accessor: 'statusName',
    id: 'statusName',
  },
  {
    Header: (props) => (
      <JudolCustomHeader
        tableProps={props}
        title='Actions'
        className='text-end w-150px'
        enableSort={false}
        stickyEnd={0}
      />
    ),
    id: 'actions',
    Cell: ({...props}) => (
      <JudolActionsCell
        id={props.data[props.row.index].id}
        name={props.data[props.row.index].policeReportNo ?? ''}
        permission={props.data[props.row.index].button}
      />
    ),
  },
]

export {judolColumns}
